import axios from 'axios'
import isEmpty from 'lodash-es/isEmpty'

export interface VacancyAPIBody {
  visibility: string
}

export default class Api {
  constructor() {
    const config = useRuntimeConfig()
    axios.defaults.baseURL = config.public.apiBaseUrl
    axios.defaults.timeout = 10000
  }

  async post(path: string, data = {}, headers = {}) {
    let params = {}

    if (!isEmpty(data)) {
      params = data
    }

    try {
      const response = await axios.post(path, params, { headers })
      return await Promise.resolve(response)
    } catch (error) {
      return await Promise.reject(error)
    }
  }

  async postWithoutCheck(path: string, data = {}, headers = {}) {
    try {
      const response = await axios.post(path, data, { headers })
      return await Promise.resolve(response)
    } catch (error) {
      return await Promise.reject(error)
    }
  }

  async put(path: string, data = {}, headers = {}) {
    const conf = {
      headers,
      params: {}
    }

    if (!isEmpty(data)) {
      conf.params = data
    }

    try {
      const response = await axios.put(path, conf)
      return await Promise.resolve(response)
    } catch (error) {
      return await Promise.reject(error)
    }
  }

  async get(path: string, data = {}, headers = {}) {
    const conf = {
      params: {},
      headers
    }

    if (!isEmpty(data)) {
      conf.params = data
    }

    return await axios
      .get(path, conf)
      .then((response) => response.data)
      .catch((error) => (error?.response ? error?.response.data : {}))
  }
}
